import styles from './card.module.css'
import Button from "../../sharedComponents/Button/button";
import {useState} from "react";
import ProductDetail from "../../sharedComponents/productDetail/productDetail";
const Card = (props) => {
	let name = props.name
	let price = props.price
	let weight = props.weight
	let imag = props.imageUrl
	const [getHeight, setHeight] = useState('auto')
	const [getWidth, setWidth] = useState('150px')
	const [getModel, setModel] = useState(false)

	function getImageSize(e) {
		const [height] = [e.target.offsetHeight, e.target.offsetWidth]
		if (height > 245) {
			setHeight('245px')
			setWidth('auto')
		}
	}

	const closeModel = () => {
	  setModel(false)
	}
	const showModel = () => {
		setModel(true)
	}
  return (
	  <>
		  <div className={styles.container}>
			  <div className={styles.image}>
				  <img onLoad={getImageSize} height={getHeight} width={getWidth} src={imag} alt=""/>
			  </div>
			  <div className={styles.innerContainer}>
				  <div className={styles.name}><span>Name:</span> <span>{name}</span></div>
				  <div className={styles.price}><span>Price:</span> <span>{price} INR</span></div>
				  <div className={styles.weight}><span>Weight:</span> <span>{weight}g</span></div>
				  <div className={styles.button} onClick={showModel}>
					  <Button>Learn More</Button>
				  </div>
			  </div>
		  </div>
		  {getModel ? <ProductDetail {...props} onClose={closeModel}/> : null}

	  </>
  )
}

export default Card